// src/landing/LandingPage.js
import React from 'react';
import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import CallToAction from './CallToAction';

// Remove the Navbar import - AuthLayout will handle this

const LandingPage = () => {
  return (
    <div>
      {/* Remove the Navbar component - it's included by AuthLayout */}
      <Hero />
      <Features />
      <HowItWorks />
      <CallToAction />
    </div>
  );
};

export default LandingPage;